/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Icon } from '@pypestream/design-system';

import { useProStudioCtxSelector } from '../../../xstate/app.xstate';
import { useProStudioViewerRole } from '../../../hooks';
import { useScriptEditor } from '../../../hooks/use-script-editor';
import { findCommandScriptPath } from './find-command-script-path';

/**
 * Under an action node's Command: opens the solution's real script for that
 * command in the code editor, the same editor (and save) as the Actions page.
 * Built-in commands have no script, so they get a line saying so instead.
 */
export const CommandScriptLink: React.FC<{ command: string }> = ({
  command,
}) => {
  const isViewer = useProStudioViewerRole();
  const { draftFiles } = useProStudioCtxSelector((ctx) => ({
    draftFiles: ctx.draft?.files ?? [],
  }));
  const { editorModal, openScript } = useScriptEditor();

  if (!command) return null;

  const path = findCommandScriptPath(command, draftFiles);
  if (!path) {
    return (
      <p
        className="c-node-property__script-note"
        test-id="ps-node-property-command-builtin"
      >
        Built-in command, no script to open.
      </p>
    );
  }

  const name = `${command}.py`;
  return (
    <>
      <button
        type="button"
        className="c-node-property__script-link"
        test-id="ps-node-property-command-script"
        onClick={() => openScript({ name, path, type: 'scriptFile' })}
      >
        <Icon name="file-py" size="xsmall" />
        {isViewer ? `View ${name}` : `Edit ${name}`}
      </button>
      {editorModal}
    </>
  );
};
